import { useEffect, useRef } from "react";

import { toast } from "@/shared/hooks/use-toast";
import {
  consumeJustSubmitted,
  queuedSubmitToast,
  type MediaQueueInfo,
  type QueueTaskLine,
} from "@/shared/lib/queueInfo";

/**
 * 刚提交的单落到详情页、**首次**拿到任务时:若 queueInfo 说明真在排队(本户上限 / 同档忙,
 * 前面还有单)→ 补一条「已提交,前面还有 N 单,轮到后自动开始」。
 *
 * ★不发新请求:用的是详情页本来就有的那次取数/轮询结果。
 * ★toast 上限 1 条(use-toast TOAST_LIMIT=1),这条会顶替创建页的「已提交生成」;
 *   不在排队 / 老后端无 queueInfo → 什么都不做,原提示原样留着。
 * ★只认创建页 `markJustSubmitted` 标过的单(从列表点进来的老单不弹)。
 */
export function useQueuedSubmitToast(
  line: QueueTaskLine,
  task: { id: number; status: string; queueInfo?: MediaQueueInfo | null } | null | undefined
) {
  const checked = useRef<number | null>(null);
  useEffect(() => {
    if (!task || checked.current === task.id) return;
    checked.current = task.id;
    if (!consumeJustSubmitted(line, task.id)) return;
    const t = queuedSubmitToast(task.status, task.queueInfo);
    if (t) toast(t);
  }, [line, task]);
}
